var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-ui-media-zoomableimage"},[_c('div',{staticClass:"image-wrapper",style:({
			transform: `translate(${_vm.position.x}px, ${_vm.position.y}px) scale(${_vm.scale})`,
		})},[_c('img',{ref:"image",attrs:{"src":_vm.src,"draggable":"false"},on:{"load":_vm.Handle_OnImageLoad}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }